import PropTypes from 'prop-types';
import React, {useRef, useState} from 'react';

import Label from './Label';
import _ from 'lodash';

function RadioButton({
  radioId = undefined,
  label,
  group = undefined,
  checked,
  onChecked = () => {},
  disabled = false,
  reverse = false,
  blue = false,
  boldOnActive = false,
  isSelectableLabel = true,
  onFocus = undefined,
  onBlur = undefined,
  isDisableColorLabel = false,
}: {
  radioId?: string|undefined,
  label: string,
  group?: string|undefined,
  checked: boolean,
  onChecked?: ((e:React.ChangeEvent<HTMLInputElement>) => void)|undefined,
  disabled?: boolean,
  reverse?: boolean,
  blue?: boolean,
  boldOnActive?: boolean,
  isSelectableLabel?: boolean,
  isDisableColorLabel?: boolean
  onFocus?: ((e: React.FocusEvent<HTMLInputElement>) => void)|undefined,
  onBlur?: ((e: React.FocusEvent<HTMLInputElement>) => void)|undefined,
}) {
  const [focus, setFocus] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const inputId = radioId || _.uniqueId('ifms-text-');

  let cssClass = `${radioId} ifms-tabable ifms-radiobutton`;
  // if (!disabled) {
  //   cssClass = `${cssClass} ifms-tabable-active`;
  // } 
  if(disabled) {
    cssClass = `${cssClass} ifms-radio-disabled-customize`;
  }

  function processCheckedNative(e:React.ChangeEvent<HTMLInputElement>) {
    if (disabled) {
      return;
    }

    onChecked(e);
  }

  function onCheckedWrapper(e:React.ChangeEvent<HTMLInputElement>) {
    if (disabled) {
      return;
    }

    if (inputRef.current) {
      inputRef.current.focus();
    }

    if (onChecked) {
      onChecked(e);
    }
  }

  if (reverse) {
    return (
      <div className={cssClass}>
        <input
          id={inputId}
          ref={inputRef}
          name={group}
          type="radio"
          className={`ifms-radiobutton ifms-tabable ${!disabled ? ' ifms-tabable-active' : 'selenium-test-disabled'}`}
          // @ts-ignore:next-line
          style={{position: 'relative', top: '2px', fontWeight: checked && boldOnActive ? 'bold' : ''}}
          checked={checked}
          onChange={processCheckedNative}
          disabled={disabled}
          //disabled={false}
          onFocus={e => {
            setFocus(true);
            if (onFocus) {
              onFocus(e);
            }
          }}
          onBlur={e => {
            setFocus(false);
            if (onBlur) {
              onBlur(e);
            }
          }}
        />
        {!!label &&
          <>
            &nbsp;&nbsp;
            <Label
              blue={blue}
              bold={checked && boldOnActive}
              label={label}
              style={{ height: '11px', outline: focus ? '1px dotted black' : undefined, color: (disabled && isDisableColorLabel) ? 'rgb(128, 128, 128)' : 'black' }}
              onClick={(e: React.ChangeEvent<HTMLInputElement>) => isSelectableLabel && !disabled ? onCheckedWrapper(e) : null} />
          </>
        }
      </div>
    );  
  }
  return (
    <div className={cssClass}>
      {!!label &&
        <>
          <Label
            bold={checked && boldOnActive}
            label={label}
            style={{ height: '11px', border: focus ? '1px dotted black' : undefined }}
            onClick={(e: React.ChangeEvent<HTMLInputElement>) => isSelectableLabel && !disabled ? onCheckedWrapper(e) : null}
          />&nbsp;&nbsp;
        </>
      }
      <input
        id={inputId}
        ref={inputRef}
        name={group}
        type="radio"
        className={`ifms-radiobutton ifms-tabable${!disabled ? ' ifms-tabable-active' : 'selenium-test-disabled'}`} //ifms-radio-disabled for using selenium test script
        // @ts-ignore:next-line
        style={{position: 'relative', top: '2px', fontWeight: checked && boldOnActive ? 'bold' : ''}}
        checked={checked}
        onChange={processCheckedNative}
        disabled={disabled}
        //disabled={false}  // Why ? 이 기능이 필요한 곳도 있는데 무조건 false로 설정하면 안됨. 이 경우가 필요하면 호출하는 곳에서 무조건 false로 되게 해야지 기능 자체에 disanle을 없애면 어쩌나..
        onFocus={e => {
          setFocus(true);
          if (onFocus) {
            onFocus(e);
          }
        }}
        onBlur={e => {
          setFocus(false);
          if (onBlur) {
            onBlur(e);
          }
        }}
      />
    </div>
  );
}

RadioButton.defaultProps = {
  onChecked: () => {},
  disabled: false,
  checked: false,
  reverse: false,
  blue: false,
  boldOnActive: false,
  isSelectableLabel: true,
};

RadioButton.propTypes = {
  radioId: PropTypes.string,
  label: PropTypes.string,
  group: PropTypes.string,
  onChecked: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  reverse: PropTypes.bool.isRequired,
  blue: PropTypes.bool.isRequired,
  boldOnActive: PropTypes.bool.isRequired,
  isSelectableLabel: PropTypes.bool.isRequired,
};


export default React.memo(RadioButton);
